import { render, staticRenderFns } from "./PurchaseEmployeeView.vue?vue&type=template&id=01f1efda"
import script from "./PurchaseEmployeeView.vue?vue&type=script&lang=js"
export * from "./PurchaseEmployeeView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports